export enum STEPS {
  CONTENT = 0,
  SITES = 1
}

export interface StepType {
  id: STEPS;
  label: string;
  icon: React.ReactNode;
  component: React.ReactNode;
}
export interface GlobalDocumentState {
  name: string;
  type: string;
  /* eslint-disable @typescript-eslint/no-explicit-any */
  file: any;
  sf_account_ids: string[];
  /* eslint-disable @typescript-eslint/no-explicit-any */
  accounts?: any[];
}
export interface EditionFormDataType {
  name: string;
  type: string;
  file: File | null;
  sf_account_ids: string[];
  /* eslint-disable @typescript-eslint/no-explicit-any */
  accounts?: any[];
}

export interface IEditionFormWrapperProps {
  updateId?: string;
  initialState: EditionFormDataType;
  children: React.ReactNode;
}

export interface IEditionModalProps {
  steps: StepType[];
  isLoading: boolean;
  onSave?: () => Promise<void>;
}

export interface DocumentFormValues {
  name: string;
  type: string;
  file: string | null;
  sf_account_ids: string[];
  accounts?: any[];
}
